module.exports = __webpack_public_path__ + "static/media/JP_RB_EYELASHES01.752a1a66.jpg";